var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 726,
    height: 331,
    viewBox: "0 0 726 331",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.431 123.93L166.016 285.785L42.0529 176.785L198.431 123.93Z",
    fill: "#404572"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M601.877 36.1315L700.943 83.9083L610.034 145.814L601.877 36.1315Z",
    fill: "#404572"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M375.868 63.9129L412.838 111.554L469.572 91.1146L435.687 140.997L472.658 188.638L414.746 171.827L380.861 221.709L378.954 161.436L321.042 144.625L377.775 124.186L375.868 63.9129Z",
    fill: "#404572"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M243.916 56.9372L220.397 68.0048L223.655 93.7934L205.861 74.8449L182.341 85.9125L194.863 63.1341L177.07 44.1857L202.603 49.0563L215.125 26.2779L218.383 52.0665L243.916 56.9372Z",
    fill: "#404572"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.e0975cb5.svg";
export { ForwardRef as ReactComponent };